<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <HalfCircleSpinner />
      <div class="spinner-message my-3 text-center">
        Loading Ideal Career Opportunities...
      </div>
    </template>
    <div class="font_Montserrat v3_color_black_knight">
      <b-row>
        <b-col cols="12" md="6" class="mb-3">
          <h2 class="font_size_1250rem mb-0 mobile-screen-text">
            <strong>Ideal Career Opportunities</strong>
          </h2>
        </b-col>
        <b-col cols="12" md="6">
          <div class="d-flex justify-content-end mobile-screen-button">
            <ico-alerts-button-modal
              class="mr-2 mb-3"
              v-if="isIcoAlertsVisible"
            />
            <span id="create_btn_wrapper">
              <b-button
                class="btn-kowloon"
                variant="mr-2 mb-1 mb-lg-0"
                @click="onNewJobProfile"
                :style="{ padding: '10px 20px' }"
              >
                <template v-if="!isCreateLoading">Create ICO</template>
                <template v-else>
                  <b-spinner small />
                </template>
              </b-button>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="isJobIcoNamePopup">
        <b-col cols="12" class="px-4 px-md-3 mb-3">
          To create a new desired Ideal Career Opportunity profile, 1. Click “Create ICO”, 2. Enter a name for that profile, 3. Click “Save” and define the specific terms of your desired opportunity.
        </b-col>
        <b-col cols="12" class="px-4 px-md-3">
          <job-profile-title-intial-card            
            @cancel="onCancelNewJobProfile"            
            @form-submit="onRenameJobProfile"
          />
        </b-col>
      </b-row>
      <b-row  v-if="!isJobIcoNamePopup">
      <b-col cols="12" class="px-4 px-md-3 mt-3">
        To create a new desired Ideal Career Opportunity profile, 1. Click “Create ICO”, 2. Enter a name for that profile, 3. Click “Save” and define the specific terms of your desired opportunity.
      </b-col>
      </b-row>
      <div class="mt-3">
        <b-row v-if="(jobProfiles || []).length === 0">
          <b-col cols="12" class="text-center">
            <slot name="empty-list-text">
              <span>
                You have not created an ICO yet. Create one by clicking the
                ‘Create ICO’ button above.
              </span>
            </slot>
          </b-col>
        </b-row>
        <div v-else>
          <div class="pb-4">
            <h2 class="font_size_1000rem font_weight_bold mb-4">
              Active Opportunities
            </h2>
            <template v-if="activeJobProfiles.length">
              <job-profile-card
                v-for="profile in activeJobProfiles"
                :key="profile.id"
                :profile="profile"
                :job-questions="jobQuestions"
                @delete-job-profile="onDeleteJobProfile"
                @update-job-profile-decline-status="
                  onUpdateJobProfileDeclineStatus
                "
              />
            </template>
            <div v-else>
              <i>You have no active Ideal Career Opportunity Profiles.</i>
            </div>
          </div>
          <div class="pb-4">
            <h2 class="font_size_1000rem font_weight_bold mb-4">
              Declined Opportunities
            </h2>
            <template v-if="declinedJobProfiles.length">
              <job-profile-card
                v-for="profile in declinedJobProfiles"
                :key="profile.id"
                :profile="profile"
                :job-questions="jobQuestions"
                :is-declined-matches="true"
                @delete-job-profile="onDeleteJobProfile"
                @update-job-profile-decline-status="
                  onUpdateJobProfileDeclineStatus
                "
              />
            </template>
            <div v-else>
              <i>You have not declined any job opportunities.</i>
            </div>
          </div>
          <div class="pb-4">
            <h2 class="font_size_1000rem font_weight_bold mb-4">
              Deleted ICOs
            </h2>
            <template v-if="deletedJobProfiles.length">
              <job-profile-card
                v-for="profile in deletedJobProfiles"
                :key="profile.id"
                :profile="profile"
                :job-questions="jobQuestions"
                @delete-job-profile="onDeleteJobProfile"
                @undelete-job-profile="onUndeleteJobProfile"
                @update-job-profile-decline-status="
                  onUpdateJobProfileDeclineStatus
                "
              />
            </template>
            <div v-else>
              <i>You have not deleted any job opportunities.</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-wait>
</template>

<script>
import JobProfileCard from '@/components/exchange/JobProfileCardV3';
import { HalfCircleSpinner } from 'epic-spinners';
import IcoAlertsButtonModal from '@/components/dashboard/ico-alerts/IcoAlertsButtonModal';
import JobProfileTitleIntialCard from '@/components/exchange/job-profile-details/JobProfileTitleIntialCard';
import {
  CREATE_JOB_PROFILE_ACTION,
  GET_JOB_PROFILES_ACTION,
} from '@/store/jobProfiles';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

export default {
  name: 'JobProfilesListV3',
  components: {
    HalfCircleSpinner,
    JobProfileCard,
    IcoAlertsButtonModal,  
    JobProfileTitleIntialCard
  },
  data: function () {
    return {
      isCreateLoading: false,
      isJobIcoNamePopup: false,
      profile: {name:""},
      jobQuestions: [],
    };
  },
  created: function () {
    this.uploadJobProfiles();
  },
  computed: {
    jobProfiles: function () {
      return this.$store.state.jobProfiles.items;
    },
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    isIcoAlertsVisible: function () {
      return [
        'dev.phairify.com',
        'demo.phairify.com',
        'localhost:8080',
      ].includes(window.location.host);
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode || this.$store.state.user.is_demo;
    },
    activeJobProfiles: function () {
      return this.jobProfiles.filter((jp) => {
        if (jp.deleted) return false;
        if (!jp.jobProfileJobOfferMatches || !jp.jobProfileJobOfferMatches.length) return true;
        return jp.jobProfileJobOfferMatches.some((jPJOM) => {
          return !jPJOM.is_declined;
        });
      });
    },
    declinedJobProfiles: function () {
      return this.jobProfiles.filter((jp) => {
        if (jp.deleted) return false;
        return (jp.jobProfileJobOfferMatches || []).some((jPJOM) => {
          return jPJOM.is_declined;
        });
      });
    },
    deletedJobProfiles: function () {
      return this.jobProfiles.filter((jp) => !!jp.deleted);
    },
  },
  methods: {
    uploadJobProfiles: async function () {
      try {
        this.$wait.start(this.loaderId);
        this.jobQuestions = await Api.getAllActiveJobQuestions();
        await this.$store.dispatch(GET_JOB_PROFILES_ACTION);
      } catch (e) {
        this.$toasted.error('Unable to upload data, please try again later', {
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.loaderId);
      }
    },    
    onCancelNewJobProfile: function () {      
      this.isJobIcoNamePopup = false;     
    },
    onNewJobProfile: async function () {
      this.isCreateLoading = true;
      try {
        // const newProfile = await this.$store.dispatch(
        //   CREATE_JOB_PROFILE_ACTION
        // );
        
        // this.$router.push({
        //   name: `jobProfilePage`,
        //   params: {
        //     isNew: true,
        //     id: (newProfile || {}).id,
        //   },
        // });
        if(this.isJobIcoNamePopup){
          this.isJobIcoNamePopup = false;
        }else{
          this.isJobIcoNamePopup = true;
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isCreateLoading = false;
      }
    },
    onRenameJobProfile: async function (newTitle) {
      // eslint-disable-next-line no-unused-vars

      this.$wait.start('menu-loading');
  
      const newProfile = await this.$store.dispatch(
          CREATE_JOB_PROFILE_ACTION,
          { title: newTitle }
        );
        
        this.$router.push({
          name: `jobProfilePage`,
          params: {
            isNew: true,
            id: (newProfile || {}).id,
          },
        });
      this.$wait.end('menu-loading');
    },
    onDeleteJobProfile: async function (id) {
      try {
        const jobProfile = await Api.deleteUserJobProfile(id);
        const index = this.jobProfiles.findIndex((jp) => jp.id === id);
        this.$set(this.jobProfiles[index], 'deleted', jobProfile.deleted);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      }
    },
    onUndeleteJobProfile: async function (id) {
      try {
        await Api.unDeleteJobProfile(id);
        const index = this.jobProfiles.findIndex((jp) => jp.id === id);
        this.$set(this.jobProfiles[index], 'deleted', null);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      }
    },
    onUpdateJobProfileDeclineStatus: function (id, isDeclined) {
      const index = this.jobProfiles.findIndex((jp) => jp.id === id);
      if (index === -1) return;
      this.$set(this.jobProfiles[index], 'is_declined', isDeclined);
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .mobile-screen-text {
    text-align: center !important;
  }
  .mobile-screen-button {
    justify-content: center !important;
  }
}
</style>
